import {
    Dialog,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import config from '../../../config.json'
import { DropPaper } from '../DropPaper'
import MainButton from '../../common/util/input/MainButton'

export const DisplayAllImagesDialog = ({
    attributes,
    selectedDisplayAllImagesAttribute,
    setSelectedDisplayAllImagesAttribute,
}) => {
    const closeDialog = () => {
        setSelectedDisplayAllImagesAttribute(null)
    }

    return (
        <Dialog
            open={selectedDisplayAllImagesAttribute !== null}
            onClose={() => {
                closeDialog()
            }}
            fullWidth
            maxWidth="md"
        >
            <DropPaper
                noMargin
                title={`Images of the ${attributes[selectedDisplayAllImagesAttribute]?.attribute_name} layer`}
            >
                <div>
                    <TableContainer sx={{ maxHeight: '75vh' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell className="w-18">
                                        <b>Index</b>
                                    </TableCell>
                                    <TableCell className="w-28">
                                        <b>Image</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Name</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Image Resolution</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>Has Additional Layers?</b>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {attributes[
                                    selectedDisplayAllImagesAttribute
                                ]?.possible_values.map((value, index) => (
                                    <TableRow key={'row_' + index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <div className="w-24 h-24 bg-gradient-to-br from-slate-200 to-slate-400 rounded-md relative">
                                                {value.layers.map((layer) =>
                                                    layer.ipfs ? (
                                                        <img
                                                            src={
                                                                config.ipfs +
                                                                layer.ipfs
                                                            }
                                                            key={
                                                                config.ipfs +
                                                                layer.ipfs
                                                            }
                                                            className="object-contain h-full w-full absolute"
                                                        />
                                                    ) : null,
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell>{value.value}</TableCell>
                                        <TableCell>
                                            {value.layers[0].width
                                                ? `${value.layers[0].width}x${value.layers[0].height}`
                                                : `Unknown Resolution`}
                                        </TableCell>
                                        <TableCell>
                                            {value.layers.length > 1
                                                ? 'Yes'
                                                : 'No'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="flex flex-wrap justify-end mt-10">
                    <MainButton
                        className="w-full sm:w-48"
                        fullWidth
                        size="small"
                        color="danger"
                        onClick={() => {
                            closeDialog()
                        }}
                    >
                        {' '}
                        Close
                    </MainButton>
                </div>
            </DropPaper>
        </Dialog>
    )
}
